import Post from 'components/detail/Post';
import React from 'react';
import Comments from 'components/detail/Comments';

const Detail = () => {
  return (
    <div>
      <Post />
      <Comments />
    </div>
  );
};

export default Detail;
